import $ from 'jquery';

class Timeline {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.$button = $('.timeline__toggle-button');
        this.$buttonText = $('.timeline__toggle-button span');
        this.$restOfTimeline = $('.timeline__rest');

        this.$button.on('click', e => {
            this.$restOfTimeline.slideToggle(250, () => {
                this.$button.toggleClass('open');
                this.$buttonText.text(
                    this.$restOfTimeline.is(':visible') ? 'Show Less' : 'Show More'
                );
            });
        });
    }

    static init() {
        if ($('.timeline').length > 0) {
            new Timeline();
        }
    }
}

export default Timeline;
